import { BI_MODULE, TRACE_MODULE } from '@/condor/ui/components/FinsightManager/constants';

export const initialFiltersState = {
  sortBy: '',
  sortOrder: '',
  page: 1,
  perPage: 25,
  search: '',
};

export const BONDS_TRACK_LOGIN_URL = 'finsight_web.bond.investor.login';
export const TRACE_TRACK_LOGIN_URL = 'finsight_web.login.investor.trace';

export const moduleMapper = {
  [BI_MODULE]: {
    trackKey: BONDS_TRACK_LOGIN_URL,
  },
  [TRACE_MODULE]: {
    trackKey: TRACE_TRACK_LOGIN_URL,
  },
};
